import { useNavigate } from "react-router";

import NexDigital from "Assets/Admin/NexDigital.png";

import ProjectTitle from "Components/Admin/EventSelector";
import ProfileWidget from "Components/Admin/ProfileWidget";
import GetIcon from "Components/Global/Icons";

import * as S from "./styles";

import { useTheme } from "styled-components";

const HeadRight = ({ open, setOpen }) => {
  const navigate = useNavigate();
  const theme = useTheme();

  const selectProfileItem = (route) => {
    if (route && typeof route === "string") navigate(route);

    setOpen(false);
  };

  return (
    <S.Wrapper>
      <S.Menu onClick={() => setOpen(!open)}>
        {open ? (
          <GetIcon name="X" color={theme.colors.neutral.white} size="xs" />
        ) : (
          <GetIcon name="HamburguerMenu" color={theme.colors.neutral.white} />
        )}
      </S.Menu>

      <S.Logo src={NexDigital} alt="Nex Digital Logo" />

      <S.ProfileWidgetWrapper>
        <ProfileWidget onClickOption={(route) => selectProfileItem(route)} />
      </S.ProfileWidgetWrapper>

      <S.CampaignSelectorWrapper>
        {!open ? <ProjectTitle /> : <S.Empty />}
      </S.CampaignSelectorWrapper>
    </S.Wrapper>
  );
};

export default HeadRight;
